const Layers = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
  >
    <path
      d="M0.5 7.95574L7.73167 11.5716C7.83006 11.6208 7.87925 11.6454 7.93085 11.655C7.97655 11.6636 8.02345 11.6636 8.06915 11.655C8.12075 11.6454 8.16994 11.6208 8.26833 11.5716L15.5 7.95574M0.5 4.20574L7.73167 0.589901C7.83006 0.540708 7.87925 0.516111 7.93085 0.506431C7.97655 0.497856 8.02345 0.497856 8.06915 0.506431C8.12075 0.516111 8.16994 0.540708 8.26833 0.589901L15.5 4.20574L8.26833 7.82157C8.16994 7.87077 8.12075 7.89536 8.06915 7.90504C8.02345 7.91362 7.97655 7.91362 7.93085 7.90504C7.87925 7.89536 7.83006 7.87077 7.73167 7.82157L0.5 4.20574Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Layers;
